class Api {
    
    public static URL_PREFIX = process.env.REACT_APP_URL_PREFIX;
    // public static URL_PREFIX = "http://localhost:28081";
    // public static URL_PREFIX = "http://43.100.43.98:18080/api";
    public static CODE_OK = "0";
}

export default Api;
